module.exports = __webpack_public_path__ + "static/media/val-vesa.04192f44.jpg";